import { Injectable,inject } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  apprCategoryFilter: any = '';
  apprStatusFilter: any = [];
  apprDateFilter: any = '';
  counterDateFilter: any ='';
  countermeasureStatusFilter: any = '';
  countermeasureTabFilter: any = '';
  countermeasureCategoryFilter: any = '';
  counterTypeFilter: any = '';
  counterCategoryFilter: any = '';
  searchCountermeasureVal: any = '';
  reportCategoryFilter: any = '';
  reportStatusFilter: any = '';
  reportDateFilter: any = '30 Days';
  reportGroupFilter: any = '';
  apprTagFilter:any='';
  searchApprDiscVal: any = '';
  apprGroupFilter: any = '';
  isDateRange:boolean = false;
  startDate:any;
  endDate:any;
  showsubcategory:any;
  categorySelected:any;
  subcategoryList:any;
  private _snackBar = inject(MatSnackBar)
  private dataSource = new BehaviorSubject<any>(null);
currentData = this.dataSource.asObservable();
  constructor() { }


  dateFormat(dateToBeFormated: any) {
    if (dateToBeFormated !== "") {
      const date = new Date(dateToBeFormated)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${year}-${month}-${day}`
    }
    return dateToBeFormated;

  }

  removeDuplicates(arr: any, key: any) {
    const uniqueKeys = new Set();
    return arr.filter((obj: any) => {
      const value = obj[key];
      if (!uniqueKeys.has(value)) { uniqueKeys.add(value); return true; } return false;
    });
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, 'x',{
      horizontalPosition: 'center',
      verticalPosition: 'top',
      duration: 3000,
      panelClass: ['custom-snackbar-container']
    });
  }

  updateData(data: any) {
    this.dataSource.next(data);
  }

}
